import { ClientStore } from "@domain/stores/ClientStore";
import { create } from "zustand";

type InitialState = Pick<ClientStore, "allClients" | "allClientsTotal">;

const initialState: InitialState = {
  allClients: [],
  allClientsTotal: 0,
};

const clientsStore = create<ClientStore>((set) => ({
  ...initialState,
  updateAllClients(newClients, total) {
    set((state) => {
      return {
        ...state,
        allClients: newClients,
        allClientsTotal: total,
      };
    });
  },
  clear: () => {
    set((state) => {
      return {
        ...state,
        ...initialState,
      };
    });
  },
}));

export default clientsStore;
